import React, {useEffect, useState} from 'react';

export interface useScrollProps {

}

/**
 * @INFO Hook para detectar el scroll en un componente (Alternativa a react-infinite-scroll)
 * @param idContainer
 * @param callback
 * @returns
 */
const useScroll = (idContainer: string, callback: () => any) => {

  const [isBottom, updateIsBottom] = useState<boolean>(false)

  useEffect(() => {
     // @INFO Suscribir al evento de scroll en el contenedor
     const container = document.getElementById(idContainer)
     if(container){
       container.addEventListener('scroll', handleScrollContainer)
       container.addEventListener('touchmove', handleScrollContainer)
     }
     return () => {
       // @INFO Eliminar suscripciones
       const container = document.getElementById(idContainer)
       if(container){
         try {
           container.removeEventListener('scroll', handleScrollContainer)
           container.removeEventListener('touchmove', handleScrollContainer)
         } catch (error) {}
       }
     }
  })

    /**
   * @INFO Llamar a la function de obtener siguiente pagina cuando sea necesario
   */
      useEffect(() => {
      if(isBottom){
        callback()
      }else{

      }
    }, [isBottom])

  /**
   * @INFO Función de scroll del contenedor de preguntas
   */
   const handleScrollContainer = () => {
    const container = document.getElementById(idContainer)
    if(!container) return
    if((container?.scrollTop + container?.offsetHeight) > (container?.scrollHeight - 10)){
        updateIsBottom(true)
    }else{
      updateIsBottom(false)
    }
  }

  /**
   * @INFO Tratar de reconectar el scroll
   */
  const reconnect = () => {
    // @INFO Suscribir al evento de scroll en el contenedor
    const container = document.getElementById(idContainer)
    if(container){
      try {
        container.removeEventListener('scroll', handleScrollContainer)
        container.removeEventListener('touchmove', handleScrollContainer)
      } catch (error) {}
      container.addEventListener('scroll', handleScrollContainer)
      container.addEventListener('touchmove', handleScrollContainer)
    }
  }

  return {
    reconnectScroll: reconnect
  };
}

export default useScroll;
